<template>
    <div>
        <CRow>
            <CCol>
                <ejs-grid ref='grid' :dataSource='priceAreaData' :allowFiltering='true' :allowPaging='true' :allowResizing='true' :excelQueryCellInfo='excelQueryCellPA' :allowReordering='true' :allowSorting='true' :toolbar='toolbar' :editSettings='editSettings' :pageSettings='pageSettings' :filterSettings='filterOptions' :toolbarClick='toolbarClick' :actionBegin='actionBegin' :actionComplete="actionComplete" :actionFailure="actionFailure" :allowExcelExport='true' :excelExportComplete='excelExportComplete'>
                    <e-columns>
                        <e-column field='id' headerText='' :isPrimaryKey='true' :visible='false'></e-column>
                        <e-column field='priceArea' headerText='Price Area' ref='dplPricingArea' :validationRules="requiredRules" width=120 type="string"></e-column>
                        <e-column field='isMainArea' headerText='Main Area' width=120 displayAsCheckBox='true' editType='booleanedit' type='boolean'></e-column>
                        <e-column field='stateId' headerText='Country' :validationRules="requiredRules" width=120 :edit='stateParams' foreignKeyField='stateId' foreignKeyValue='stateName' :dataSource='states' editType='dropdownedit'></e-column>
                        <e-column field='description' headerText='Description' width=120 type="string"></e-column>
                    </e-columns>
                </ejs-grid>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import { DropDownList, DropDownListPlugin } from "@syncfusion/ej2-dropdowns";
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import gridOptions from '../../../common/gridOptions';
    import store from '../../../store';
    import SyncHelper from '../../../common/syncfusion'

    Vue.use(DialogUtility);
    Vue.use(GridPlugin);

    let dpState, elState
    export default {
        name: 'Price Area',
        data() {
            return {
                store: store,
                priceAreaData: SyncHelper.getDataManager("pricingArea"),
                pageSettings: gridOptions.pageSettings,
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowAdding: store.state.permissions["Permissions.PriceArea.Create"],
                    allowDeleting: store.state.permissions["Permissions.PriceArea.Delete"],
                    allowEditing: store.state.permissions["Permissions.PriceArea.Update"],
                    mode: 'Dialog'
                },
                requiredRules: { required: true },
                toolbar: ['Add', 'Delete', 'Edit', 'ExcelExport'],

                states: SyncHelper.getDataManager("utils/states"),
                stateParams: {
                    create: () => {
                        elState = document.createElement('input');
                        return elState;
                    },
                    read: () => {
                        return dpState.value;
                    },
                    destroy: () => {
                        dpState.destroy();
                    },
                    write: (args) => {
                        dpState = new DropDownList({
                            dataSource: this.states,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Country Name',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            cssClass: 'required-input'
                        });
                        dpState.appendTo(elState);
                        if (args.requestType == 'beginEdit') {
                            dpState.enabled = false;
                        }
                    }
                },
                filterOptions: gridOptions.filterSettings,
            }
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        methods: {

            toolbarClick(args) {
                gridOptions.excelExport(args, "Price Areas.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
            },
            actionBegin(args) {
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {

                    }
                }
            },
            actionBegin(args) {
                gridOptions.actionBegin(args);

                if (args.requestType == 'save') {

                    showSpinner(document.getElementById('mainSpinner'));

                }

                if (args.requestType == 'refresh') {

                    hideSpinner(document.getElementById('mainSpinner'));

                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    const arrayFields = ["priceArea"]
                    arrayFields.forEach(function (item) {
                        let inputElement = args.form.elements.namedItem(item);
                        if (inputElement) {
                            let parentDiv = inputElement.closest('.e-input-group');
                            if (parentDiv) {
                                parentDiv.classList.add('required-input');
                            }
                        }
                    });
                }

               
                if (args.requestType == 'refresh') {

                    hideSpinner(document.getElementById('mainSpinner'));

                }
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },
            excelQueryCellPA: function (args) {

                if (args.column.headerText === 'Main Area') {
                    args.value = args.value == true ? "Yes" : "No";
                }
            },
        },
        computed: {

        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    }
</script>

<style>
</style>